import * as z from 'zod';
import { PAYMENT_METHOD_TYPE } from 'src/features/paymentMethods/utils/types';

export type CustomerPaymentMethodFormSchemaValues = z.infer<typeof customerPaymentMethodFormSchema>;
export const customerPaymentMethodFormSchema = z.object({
    name: z.string().nonempty(),
    valid_from: z.string().optional().nullable(),
    valid_to: z.string().optional().nullable(),
    type: z.enum(PAYMENT_METHOD_TYPE),
    is_primary: z.boolean(),
    token: z.string().optional().nullable(),
    // details: z.string().optional().nullable(),
    customer: z.string(),
});
